import { createGlobalStyle } from "styled-components";

import Fonts from "./Fonts";
import theme from "css/theme";
import Media from "css/Media";

export default createGlobalStyle`
  ${Fonts};

  html, 
  body, 
  div, 
  span, 
  iframe, 
  h1, 
  h2, 
  h3, 
  h4, 
  h5, 
  h6, 
  p, 
  img, 
  ol, 
  ul, 
  li,
  footer, 
  header, 
  section,
  video { 
    margin: 0; 
    padding: 0; 
    border: 0; 
    font-size: 100%; 
    font: inherit; 
    vertical-align: baseline; 
  } 

  section { 
    display: block;
  } 

  body { 
    line-height: 1; 
  } 

  ol, ul { 
    list-style: none; 
  }

  * {
      box-sizing: border-box;
  }
  
  html {
      max-width: 100%;
      font-size: 16px;
  }

  body {
      font-family: "Untitled", "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
      font-weight: normal;
      font-size: 16px;
      line-height: 1.3;
      background: ${theme.colors.negative};
      color: ${theme.colors.text};
      min-height: 100vh;
      font-display: fallback;
      max-width:100%;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
  }

  a, a:hover, a:visited, a:active {
      text-decoration: none;
      color: ${theme.colors.text};
  }

  ul {
      margin: 0;
      padding: 0;
      
      li {
          margin: 0;
          padding: 0;
          list-style: none;
      }
  }

  img {
      max-width: 100%;
      height:auto;
  }

  #nprogress {
      pointer-events: none;
      .bar {
          background: red;
          position: fixed;
          z-index: 1031;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
      }
      .peg {
          display: block;
          position: absolute;
          right: 0px;
          width: 100px;
          height: 100%;
          box-shadow: 0 0 10px red, 0 0 5px red;
          opacity: 1.0;
          transform: rotate(3deg) translate(0px, -4px);
      }
      .spinner { display: none; }
  }

  /* way the hell off screen */
  .scrollbar-measure {
      width: 100px;
      height: 100px;
      overflow: scroll;
      position: absolute;
      top: -9999px;
  }

  //INPUT STYLE RESET

  input:focus, textarea:focus, select:focus {
      outline: none;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
  }

  /* Firefox */
  input[type=number] {
      -moz-appearance: textfield;
      appearance: textfield;
  }

  //CUSTOM FONT STYLES

  h1 {
      ${theme.fonts.h1};
  }
  h2 { 
      ${theme.fonts.h2};
  }
  h3 { 
      ${theme.fonts.h3};
  }
  h4 { 
      ${theme.fonts.h4};
  }

  h5 { 
      ${theme.fonts.h5};
  }
  
  p {  
      ${theme.fonts.p};
  }

  //CUSTOM STYLE FOR FLATPICKR

  .flatpickr-calendar {
    width: auto!important;
    font-family: 'Untitled'!important;
    margin-top: 20px!important;
    border: 1px solid ${theme.colors.text}!important;
    border-radius: 20px!important;
    padding: 40px!important;
    box-sizing: content-box!important;
    box-shadow: none!important;
    user-select: none!important;

    ${Media.lessThan("s")`
      position:fixed!important;
      bottom: 0!important;
      top: auto!important;
      left: 0!important;
      right: 0!important;
      width: calc(100% - 50px)!important;
      border-radius: 0!important;
      padding: 25px!important;
      height: 60vh;
    `}

    /* Hide bubble arrow */
    &.arrowTop::before,
    &.arrowTop::after,
    &.arrowBottom::before,
    &.arrowBottom::after {
        bottom: 0!important;
        display: none!important;
    }
    /* Set full width on mobile */
    .flatpickr-innerContainer {
      .flatpickr-rContainer {
        ${Media.lessThan("s")`
          width: 100%!important;
        `}
        .flatpickr-days {
          width: 100%!important;
          ${Media.lessThan("s")`
            width: 100%!important;
          `}
          .dayContainer {
            ${Media.lessThan("s")`
              width: 100%!important;
              max-width: none!important;
            `}
            .flatpickr-day {
              ${Media.lessThan("s")`
                max-width: none!important;
              `}
            }
          }
        } 
      }
    }

    .flatpickr-months {
      margin-bottom: 30px!important;

      /* Hide year on mobile */
      .flatpickr-month {
        .flatpickr-current-month {
          .flatpickr-monthDropdown-months {
            -webkit-appearance: none!important;
          }
          .numInputWrapper {
            ${Media.lessThan("s")`
                display: none!important;
            `}
          }
        }
      }
    }

    .flatpickr-prev-month,
    .flatpickr-next-month {
      svg {
        fill: ${theme.colors.text}!important;
        transition: fill .2s ease!important;
      }
      :hover {
        svg {
          fill: ${theme.colors.button}!important;
        }
      }
    }

    .flatpickr-prev-month {
      padding: 8px 0 0 15px!important;

      ${Media.lessThan("s")`
        padding: 8px 0 0 15px!important;
      `}
    }

    .flatpickr-next-month {
      padding: 8px 15px 0 0!important;

      ${Media.lessThan("s")`
        padding: 8px 15px 0 0!important;
      `}
    }

    span, .numInput {
      font-family: 'Untitled'!important;
      font-weight: normal!important;
      font-size: 16px!important;
    }
  }

  .flatpickr-month + .flatpickr-month {
    span.cur-month {
      font-size: 18px!important;
    }
  }

  .flatpickr-weekdaycontainer {
    flex: auto!important;
    width: 50%;

    span {
      font-family: 'Untitled'!important;
      font-weight: normal!important;
      font-size: 14px!important;
    }

    &:last-of-type {
      margin-left: 40px;
    }
  }

  .dayContainer {
    width: 50%;

    .flatpickr-day {
      &.selected.startRange + 
      .endRange:not(:nth-child(7n+1)), 
      &.startRange.startRange + .endRange:not(:nth-child(7n+1)), 
      &.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
          box-shadow: -5px 0 0 ${theme.colors.button}, 5px 0 0 ${
  theme.colors.button
}!important;
      }
      &.today, 
      &.startRange, 
      &.endRange {
        border: none!important;
        border-radius: 0!important;

        :hover {
          border-radius: 0!important;
          background: ${theme.colors.button}!important;
          border: none!important;
        }
      }

      &.inRange {
        background: ${theme.colors.bg}!important;
        box-shadow: -5px 0 0 ${theme.colors.bg}, 5px 0 0 ${
  theme.colors.bg
}!important;
        border: none!important;

        :nth-child(7n+1) {
          box-shadow: -2px 0 0 ${theme.colors.bg}!important;
        }
      }

      &.today {
        color: ${theme.colors.text}!important;
      }
      &.startRange {
        color: ${theme.colors.negative}!important;
        background: ${theme.colors.button}!important;
      }

      &.endRange {
        color: ${theme.colors.negative}!important;
        background: ${theme.colors.button}!important;
        box-shadow: -5px 0 0 ${theme.colors.bg}!important;
      }

      :hover {
        border-radius: 0!important;
        background: ${theme.colors.input}!important;
        border: none!important;
      }
    }
    &:last-of-type {
      margin-left: 40px;
    }
  }
  .dayContainer + .dayContainer {
    box-shadow: none!important;
  }
`;
